
class Menushow {
    getMenu = () => {
      var values = {
        "dmtShow":"yes",
        "billPayShow":"yes",
        "rechargeShow":"yes",
        "payOutShow":"no",
        "aepsShow":"no",
        "kycShow":"no"
      }
      return values;
    }
  
  }
  export default new Menushow();